import React from 'react';
import { CountdownBanner } from '../components/CountdownBanner';
import { HeroSection } from '../components/HeroSection';
import { CartaNatalSection } from '../components/CartaNatalSection';
import { PainSection } from '../components/PainSection';
import { ReframeSection } from '../components/ReframeSection';
import { ProductSection } from '../components/ProductSection';
import { StackSection } from '../components/StackSection';
import { LimitedOfferSection } from '../components/LimitedOfferSection';
import { ForYouSection } from '../components/ForYouSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTA } from '../components/FinalCTA';
import { EmotionalClose } from '../components/EmotionalClose';
import { FAQSection } from '../components/FAQSection';
export function SalesPage() {
  return <main className="min-h-screen w-full font-body text-burgundy-800 bg-cream-50 selection:bg-dusty-rose-200 selection:text-burgundy-900" data-id="element-298">
      <CountdownBanner data-id="element-299" />
      <HeroSection data-id="element-300" />
      <PainSection data-id="element-301" />
      <ReframeSection data-id="element-302" />
      <ProductSection data-id="element-303" />
      <StackSection data-id="element-304" />
      <CartaNatalSection data-id="element-305" />
      <LimitedOfferSection data-id="element-306" />
      <ForYouSection data-id="element-307" />
      <TestimonialsSection data-id="element-308" />
      <FinalCTA data-id="element-309" />
      <GuaranteeSection data-id="element-310" />

      <EmotionalClose data-id="element-311" />
      <FAQSection data-id="element-312" />
    </main>;
}